import {makeObservable, observable} from "mobx";
import {observer} from "mobx-react";
import {Component} from "preact";
import logo from "../img/logo.svg";
import {fancyAlert, signUp} from "../model";
import {resources} from "../resources";
import {Button} from "./controls/Button";
import {TextInput} from "./controls/TextInput";
import style from "./SignUpView.module.css";

export const SignUpView = observer(
	class SignUpView extends Component {
		private phone = "";
		private pending = false;
		private success = false;

		constructor(props: {}) {
			super(props);
			makeObservable<SignUpView, "phone" | "pending" | "success">(this, {
				phone: observable,
				pending: observable,
				success: observable,
			});
		}

		render() {
			return (
				<div class={style.signUpView}>
					<img src={logo} alt={"VarioCube"} class={style.logo} />

					<div class={style.title}>
						{resources.strings.SignUpTitle}
					</div>

					{!this.success && (
						<div>
							<div class={style.message}>
								{resources.strings.SignUpMessage}
							</div>
							<form onSubmit={this.handleFormSubmit}>
								<TextInput
									value={this.phone}
									onChange={this.handlePhoneChange}
									disabled={this.pending}
									type={"phone"}
									required
									placeholder={resources.strings.MobileNumber}
								/>
								<Button primary type="submit" disabled={this.pending} pending={this.pending}>
									{resources.strings.SignUp}
								</Button>
							</form>
						</div>
					)}

					{this.success && (
						<div class={style.message}>
							{resources.strings.SignUpSuccessMessage}
						</div>
					)}
				</div>
			);
		}

		private handlePhoneChange = (newPhone: string) => this.phone = newPhone;

		private handleFormSubmit = async (e: Event) => {
			console.log("form submit");
			e.preventDefault();
			try {
				this.pending = true;

				// Filter out characters that are not digits or the plus sign
				const phone = this.phone.replace(/[^0-9+]/, "");

				await signUp(phone, resources.language.toString());
				this.success = true;
			}
			catch (error) {
				console.error("Error during signup", error);
				fancyAlert(resources.strings.SignUpFailedMessage);
			}
			finally {
				this.pending = false;
			}
		};
	},
);
